import styled from 'styled-components';

const Wrapper = styled.div`
    width: calc(100vw - 800px - 100px);
    // min-width: ${props => !props.showDetail ? "0px" : "450px"};
    max-width: ${props => !props.showDetail ? "0px" : "540px"};
    transition: 0.5s;
    -webkit-transition: 0.5s;
    -o-transition: 0.5s;
    -moz-transition: 0.5s;
    transition: calc(100vh - 73px);
    background: #F5F7F8;
    top: 73px;
    overflow: auto;
    @media only screen and (max-width: 1024px) {
        width:  ${props => !props.showDetail ? "0px" : "100vw"};
        height: ${props => !props.showDetail ? "0px" : "100vh"};;
        position: fixed !important;
        top: 0;
        left: 0;
        max-width: none;
        max-height: none;
        z-index: 99;
    }
`;

export default Wrapper;